export default __webpack_public_path__ + "static/media/challengeIllutration.2b41fcf9.png";